module.exports = __webpack_public_path__ + "static/media/kcaa_logo.54aa8951.png";